import styled from 'styled-components';
import { Button } from 'antd';

export const PrimaryButton = styled(Button)`
  width: 15em;
  margin-right: 1em;
  color: ${(props) => props.theme.color};
  background-color: ${(props) => props.theme.primaryColor};
`;
